import { defineStore } from "pinia";
import { useSystemStore } from "./system";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: '',
        user: {},
        universal: '/',
        authError: false,
    }),
    getters: {
        loggedIn: (state) => !!state.token && !!state.user,
    },
    actions: {
        setToken(tokenValue) {
            localStorage.setItem('token', tokenValue);
            this.token = tokenValue;
            axios.defaults.headers.common['Authorization'] = `Bearer ${tokenValue}`;
            socketInstance.setAuthToken(`Bearer ${tokenValue}`);
        },
        clearToken() {
            localStorage.removeItem('token');
            this.token = '';
            axios.defaults.headers.common['Authorization'] = '';
            socketInstance.setAuthToken('');
        },
        async loginWithToken(tokenValue) {
            this.setToken(tokenValue);
            await this.fetchUser().catch(() => {
                this.logout();
            });
        },
        async login(form) {
            const res = await useApi().login(form);
            if (res && res.status == 'OK') {
                this.setToken(res.data.token);
                await this.fetchUser();
                this.$router.push(this.universal);
                return true;
            }
            return false;
        },
        logout(api = false) {
            this.authError = true;
            setTimeout(() => {
                this.authError = false;
            }, 10000);
            this.universal = '/';

            if (api)
                useApi().logout().catch(() => { });
            this.user = {};
            this.clearToken();
            this.$router.push({ path: '/login' });
            setTimeout(() => {
                useSystemStore().clearSystemData();
            }, 500);
        },
        setUniversal(path) {
            this.universal = path;
        },
        async fetchUser(refresh = false) {
            let lsToken = localStorage.getItem('token');
            if (lsToken && lsToken !== this.token)
                this.setToken(lsToken);
            if (this.token && (!Object.keys(this.user).length || refresh)) {
                const res = await useApi().me();
                if (res && res.status == 'OK')
                    this.user = res.data.user;
            }
        },
    }
});
